import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={32}
      height={34}
      viewBox="0 0 32 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 17.25c0-8.837 7.163-16 16-16s16 7.163 16 16-7.163 16-16 16-16-7.163-16-16zm17.6-6.4a1.6 1.6 0 10-3.2 0 1.6 1.6 0 003.2 0zM16 25.25a1.6 1.6 0 001.6-1.6v-6.4a1.6 1.6 0 00-3.2 0v6.4a1.6 1.6 0 001.6 1.6z"
        fill="#FF7A00"
      />
    </Svg>
  );
}

export default SvgComponent;
